import { atom } from 'recoil';
import { type ProductStatus } from '../types/onsaTypes';
import { onsaProductStatusListSelector } from '../selectors/onsaProductStatusListSelector';

export const onsaProductStatusListAtom = atom<Record<string, ProductStatus[]>>({
    key: 'onsaProductStatusList',
    default: onsaProductStatusListSelector
});
